import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Shops from "./pages/Shops";
import Card from "./pages/Card";
import Details from "./pages/Details";
import Register from "./pages/Register";
import Login from "./pages/Login";
import VerifyEmail from "./pages/VerifyEmail";
import VerifyPending from "./pages/VerifyPending";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Shipping from "./pages/Shipping";
import { useDispatch } from "react-redux";
import { get_category } from "./store/reducers/homeReducer";
import { initialize_auth } from "./store/reducers/authReducer";
import CategoryShops from "./pages/CategoryShop";
import SearchProducts from "./pages/SearchProducts";
import Payment from "./pages/Payment";
import Dashboard from "./pages/Dashboard";
import ProtectUser from "./utils/ProtectUser";
import Index from "./components/dashboard/Index";
import Orders from "./components/dashboard/Orders";
import Wishlist from "./components/dashboard/Wishlist";
import ChangePassword from "./components/dashboard/ChangePassword";
import Order from "./components/dashboard/Order";
import Chat from "./components/dashboard/Chat";
import ConfirmOrder from "./pages/ConfirmOrder";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import About from "./pages/about/About";
import WhatsAppButton from "./components/WhatsAppButton";
function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(get_category());
    dispatch(initialize_auth());
  }, [dispatch]);

  return (
    <div className="max-w-screen min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <WhatsAppButton />
        <Routes>
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify-pending" element={<VerifyPending />} />
          <Route path="/email-verify" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={<Home />} />
          <Route path="/shops" element={<Shops />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<CategoryShops />} />
          <Route path="/products/search" element={<SearchProducts />} />
          <Route path="/card" element={<Card />} />
          <Route path="/order/success/:orderId" element={<ConfirmOrder />} />
          <Route path="/product/details/:slug" element={<Details />} />

          <Route element={<ProtectUser />}>
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/payment" element={<Payment />} />
          </Route>

          <Route path="/dashboard" element={<ProtectUser />}>
            <Route element={<Dashboard />}>
              <Route index element={<Index />} />
              <Route path="my-orders" element={<Orders />} />
              <Route path="my-wishlist" element={<Wishlist />} />
              <Route path="order/details/:orderId" element={<Order />} />
              <Route path="chage-password" element={<ChangePassword />} />
              <Route path="chat" element={<Chat />} />
              <Route path="chat/:sellerId" element={<Chat />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

//test comment
